module.exports = __webpack_public_path__ + "img/xmasParty17.ee8c14af.jpg";